
export class PremierServiceProductDTO{
    public id!: number;
    public serviceId!: number;
    public name!: string;
    public productTypeId!: string;
    public contextType!: string;
    public contextId!: number;
    public parameterTemplate!: string;
    public canSchedule!: boolean;
    public restrictedToMoovStepDefinitionId!: number;
    public enabled!: boolean;
    public added!: string;
    public edited!: string;
}